import React from "react";
import { Link } from "react-router-dom";

export const NoMatch = () => {
	return (
		<div
			style={{
				flex: "1 1 auto",
				minHeight: "100%",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
			}}>
			<h1>Página não encontrada :(</h1>
			<Link to={`${process.env.PUBLIC_URL}/#wellcome`}>Voltar para a home</Link>
		</div>
	);
};

export default NoMatch;
